// 英文 数字 -
export const codeFn = (rules, value, cb) => {
    let reg = /^[a-zA-Z0-9_]{0,20}$/;
    if (!reg.test(value)) {
        cb($t('integration.only_english_c__numbers_c__and_underscores_are_allowed'))
    }
    cb()
}
